import React from "react";
import { connect } from "react-redux";
import { View, Text, Image, TouchableOpacity } from "react-native";
import FontAwesomeIcon from "react-native-vector-icons/dist/FontAwesome";
import { withTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { Container, Content, Left, Body, Right, Button, Title } from "native-base";
import _ from "lodash";
import Header from "../../components/ui/WrappedHeader";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import ScreenLoadingIndicator from "../../components/ui/ScreenLoadingIndicator";
import { NavigationService } from "../../navigation";
import UIDs from "../../UIDs";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../redux/screens/homework/ArticleRedux";
import Icon from "react-native-vector-icons/Ionicons";
import { AppStyles } from "../../theme/index";
import NavigateActionTypes from "../../navigation/NavigateActionTypes";
import * as Helper from "../../utils/Helper";
import UnitViews from "../course/units";
import styles from "../StyleHelper";
import { getRealUnitType } from "../../utils/Helper";
import { WebView } from "react-native-webview";

const uid = UIDs.screens.homework.article;

class ArticleScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        //let { id } = this.localVars.navParams;
        let { id, article } = this.props;
        if (!id) {
            id = this.localVars.navParams.id;
        }

        if (!article) {
            article = this.localVars.navParams.article;
        }

        this.props.loadScreenViewAsync(id, article);
    }

    refreshScreen() {
        //let { id } = this.localVars.navParams;
        let { id, article } = this.props;
        if (!id) {
            id = this.localVars.navParams.id;
        }

        if (!article) {
            article = this.localVars.navParams.article;
        }

        this.props.loadScreenViewAsync(id, article);
    }

    hasArticle() {
        if (this.props.article) {
            return true;
        }
        if (this.localVars.navParams.article) {
            return true;
        }
        return false;
    }

    renderArticle(article) {
        let HeaderBodyMgLeft = 25;
        let HeaderBodyPad = 0;
        const html = `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8">
    <title>ChatView</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"  </head>
${Helper.replaceHtmlVirtualPath(article.htmlContent)}
  <body>
  </body>
</html>`;
        return(
            <Container style={{width:"100%"}}>
                <Header hasTabs style={styles.headerColor}>
                    <Body style={[styles.headerBody]}>
                        <View style={{ zIndex: 100 }}>
                            <Button transparent onPress={() => {
                                        if (this.props.onClose) {
                                            this.props.onClose();
                                        }
                                        else {
                                            NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
                                        }
                                    }}>
                                <Icon style={{fontSize:30, color:"#777", paddingLeft:12}} name="ios-arrow-back" />
                            </Button>
                        </View>
                        <View style={{ marginLeft: HeaderBodyMgLeft, flex: 1, paddingHorizontal: HeaderBodyPad, zIndex: 10, }}>
                            <Title style={[styles.headerTitle]}>{this.props.t("articletitle2")}</Title>
                        </View>
                        <View style={[styles.flexDirection, {width: 40, alignItems: 'center'}]}>
                        </View>
                    </Body>
                </Header>
                <View style={{ flex: 1, paddingLeft: 12, paddingRight: 12 }}>
                    <WebView source={{ html: html, baseUrl: "web/" }} style={{ flex: 1 }} mixedContentMode="always" originWhitelist={["*"]} />
                </View>
            </Container>);
    }

    renderScreen() {
        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) return <ScreenLoadingIndicator title={this.hasArticle() ? this.props.t("articletitle2") : this.props.t("articletitle")} />;
        let {article, unitData, settings, pinyin, translation, unitType} = this.props.localState;
        const result = { score:0, answer: null, files: null };

        if (article) {
            return this.renderArticle(article);
        }

        if (!unitData) {
            return (
                <Container style={{width:"100%"}}>
                    <Header style={styles.headerColor}>
                        <Left>
                            <Button transparent onPress={() => {
                                        if (this.props.onClose) {
                                            this.props.onClose();
                                        }
                                        else {
                                            NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
                                        }
                                    }}>
                                <Icon style={{fontSize:30, color:"#777"}} name="ios-arrow-back" />
                            </Button>
                        </Left>
                        <Body style={[{ flex: 3 }]} />
                        <Right />
                    </Header>
                    <View style={{ justifyContent: "center", alignItems: "center", flex: 1 }}>
                        <Text>{this.props.t("noContent")}</Text>
                    </View>
                </Container>
            );
        } else {
            const UnitView = UnitViews[getRealUnitType(unitType)];
            let HeaderBodyMgLeft = 25;
            let HeaderBodyPad = 0;
            return(
                <Container style={{width:"100%"}}>
                    <Header hasTabs style={styles.headerColor}>
                        <Body style={[styles.headerBody]}>
                            <View style={{ zIndex: 100 }}>
                                <Button transparent onPress={() => {
                                            if (this.props.onClose) {
                                                this.props.onClose();
                                            }
                                            else {
                                                NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
                                            }
                                        }}>
                                    <Icon style={{fontSize:30, color:"#777", paddingLeft:12}} name="ios-arrow-back" />
                                </Button>
                            </View>
                            <View style={{ marginLeft: HeaderBodyMgLeft, flex: 1, paddingHorizontal: HeaderBodyPad, zIndex: 10, }}>
                                <Title style={[styles.headerTitle]}>{this.props.t("articletitle")}</Title>
                            </View>
                            <View style={[styles.flexDirection, {alignItems: 'center'}]}>
                                {<TouchableOpacity transparent onPress={this._setPinyinVisible} style={[styles.headerRightIconPad, styles.headerRightIconPinyinPad]}>
                                    <Text uppercase={false} style={[settings.pinyinVisible ? styles.headerRightIconSelectedColor : styles.headerRightIconDefColor, { fontSize: 25, paddingRight:10 }]}>ā</Text>
                                </TouchableOpacity>}
                                {<TouchableOpacity transparent onPress={this._setTranslateVisible} style={[styles.headerRightIconPad, styles.headerRightIconTransPad]}>
                                    <FontAwesomeIcon name="language" style={[settings.translationVisible ? styles.headerRightIconSelectedColor : styles.headerRightIconDefColor, { fontSize: 20 }]}></FontAwesomeIcon>
                                </TouchableOpacity>}
                            </View>
                        </Body>
                    </Header>
                    <View style={{ flex: 1 }}>
                        <UnitView
                            data={unitData}
                            childIndex={0}
                            result={result}
                            mode={2} // 0: study, 1: exam, 2: readonly
                            key={this.localVars.navParams.id}
                            settings={settings}
                        />
                    </View>
                </Container>
            )
        }
    }

    _setPinyinVisible = () => {
        let settings = { ...this.props.localState.settings };
        settings.pinyinVisible = !settings.pinyinVisible;
        this.props.updateSettings(settings);
    };

    _setTranslateVisible = () => {
        let settings = { ...this.props.localState.settings };
        settings.translationVisible = !settings.translationVisible;
        this.props.updateSettings(settings);
    };
};

const styles1 = StyleSheet.create({

});

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (id, article) => dispatch(Actions.loadScreenViewAsync(id, article)),
        updateSettings: settings => dispatch(Actions.updateSettings(settings)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(ArticleScreen));
